import { FEATURES_KEYS, QUERY_SEPARATOR } from '@yme/utils/constants';
export function isProductFeaturesEmpty() {
    return true;
}
export const buildUrl = (url, query) => Array.isArray(query) ? url.replace(FEATURES_KEYS, query.join(QUERY_SEPARATOR)) : '';
export const formattingFeatureItems = (items) => items.map(({ value }) => ({
    title: value.header,
    imageUrl: value?.images?.length ? value.images[0] : null,
    description: value.body,
    isH3Title: true,
}));
